import styled from 'styled-components';

export const FeatureContainer = styled.div`
  background: #000000;
  height: 500vh;
  max-height: 175vh;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: center;
  color: #fff;
  text-align: center;
  padding: 0 1rem;

  @media screen and (max-width: 650px) {
    width: 100%;
  }

  h1 {
    font-size: clamp(2rem, 3vw, 5rem);
    margin-top: 20px;
  }

  p {
    margin-bottom: 1rem;
    font-size: clamp(1rem, 6vw, 6rem);
    margin-top: 40px;
    background: #ffc500;
    color: #000;
    border-radius: 25px;

    &:hover {
      background: #ffc500;
      transition: 0.2s ease-out;
      cursor: pointer;
      color: #000;
      transform: scale(1.5); 
    }
  }
`;
export const FeatureButton = styled.div`
  font-size: 1.4rem;
  margin-top: 15px;
  padding: 0.6rem 5rem;
  border: none;
  background: #ffc500;
  color: #000;
  transition: 0.2s ease-out;

  
`;

export const Road = styled.div`
  margin-bottom: 1rem;
  margin-top: 40px;
  background: #ffc500;
  color: #000;
  border-radius: 25px;
  font-size: 2rem;
  padding: 0.5rem 2rem;
  border: none;
  background: #ffc500;
  color: #000;
  transition: 0.2s ease-out;
  margin-right: 100px;
  margin-left: 100px;

  @media screen and (max-width: 650px) {
    width: 100%;
    margin-top: 100px;
  }

  &:hover {
    background: #ffc500;
    transition: 0.2s ease-out;
    cursor: pointer;
    color: #000;
    transform: scale(1.2); 
`
